import { nanoid } from 'nanoid';

import { type BuildQuizListItem } from './BuildQuizListSchema';

export const getBlankQuizItem = (): BuildQuizListItem => {
  return {
    id: nanoid(8),
    question: '',
    questionRichText: '',
    questionImageUrl: '',
    hint: undefined,
    type: 'multiple',
    multipleData: getBlankMultipleData(),
    subjectiveData: getBlankSubjectiveData(),
    oxData: getBlankOXData(),
    essayData: {},
    matchData: getBlankMatchData(),
    orderData: getBlankOrderData(),
  };
};

const getBlankMultipleData = () => {
  const firstChoiceKey = nanoid(8);
  return {
    choiceList: [
      {
        key: firstChoiceKey,
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: true,
      },
      {
        key: nanoid(8),
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: false,
      },
      {
        key: nanoid(8),
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: false,
      },
      {
        key: nanoid(8),
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: false,
      },
    ],
  };
};

const getBlankSubjectiveData = () => {
  const firstAnswerKey = nanoid(8);
  return {
    answerList: [{ key: firstAnswerKey, text: '' }],
  };
};

const getBlankOXData = () => {
  return {
    answer: 'o' as const,
  };
};

/**
 * 보기 4개로 시작한다(객관식과 동일). 배열 순서가 곧 정답 순서이므로
 * 별도의 정답 필드를 만들지 않는다.
 * @see form/schema/quiz/QuizOrderDataSchema.ts
 */
const getBlankOrderData = () => {
  return {
    items: Array.from({ length: 4 }, () => ({
      id: nanoid(8),
      text: '',
      richText: '',
      imageUrl: undefined,
    })),
  };
};

const getBlankMatchData = () => {
  const pairIds = Array.from({ length: 4 }, () => ({
    leftId: nanoid(8),
    rightId: nanoid(8),
  }));

  return {
    leftItems: pairIds.map(({ leftId }) => ({
      id: leftId,
      text: '',
      richText: '',
      imageUrl: undefined,
    })),
    rightItems: pairIds.map(({ rightId }) => ({
      id: rightId,
      text: '',
      richText: '',
      imageUrl: undefined,
    })),
    answerPairs: pairIds.map(({ leftId, rightId }) => ({ leftId, rightId })),
  };
};
